import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { FONTS, SPACES } from 'src/constants'

const useStyles = makeStyles((theme: Theme) => ({
  modalWrapper: {
    minHeight: 200,
    [theme.breakpoints.down('tablet')]: {
      minWidth: 320,
    },
    [theme.breakpoints.up('tablet')]: {
      minWidth: 400,
    },

    padding: SPACES.xxl,
  },
  cardWrapper: {
    '&&': {
      height: '100%',
      width: '390px',

      [theme.breakpoints.down('tablet_s')]: {
        width: '100%',
      },

      borderRadius: '0.9375rem',
    },
  },
  cardWrapperBorder: {
    '&&': {
      border: `1px solid ${theme.palette.custom.grey}`,
    },
  },
  titleWrapper: {
    marginBottom: SPACES.xxs,
    display: 'flex',
    justifyContent: 'space-between',
  },
  cardTitle: {
    '&&': {
      fontWeight: FONTS.WEIGHTS.medium,
      fontSize: FONTS.SIZES.xs,
      lineHeight: 1.4,
      color: theme.palette.custom.grey2,
    },
  },
  contentWrapper: {
    '&&': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
  },
  qrWrapper: {
    '&&': {
      backgroundColor: 'white',
      borderRadius: 5,
    },
  },
  buttonsWrapper: {
    '&&': {
      display: 'flex',
      gap: SPACES.s,
    },
  },

  buttonsColumn: {
    '&&': {
      flexDirection: 'column',
    },
  },

  upperTitleWrapper: {
    '&&': {
      marginBottom: SPACES.xxxs,

      display: 'flex',
      justifyContent: 'space-between',
    },
  },
  overrideWrapper: () => ({
    '&&': {
      marginTop: 10,
      padding: `${SPACES.xxxs} ${SPACES.xs}`,
      border: `1px solid ${theme.palette.custom.grey}`,
      [theme.breakpoints.down('tablet')]: {
        width: '100%',
        borderRadius: '10px',
      },
      [theme.breakpoints.up('tablet')]: {
        borderRadius: '15px',
      },
    },
  }),
  inputType: {
    '&&': {
      lineHeight: 1.33,
      color: theme.palette.custom.grey2,

      [theme.breakpoints.down('tablet')]: {
        fontSize: FONTS.SIZES.s,
        fontWeight: FONTS.WEIGHTS.light,
      },
      [theme.breakpoints.up('tablet')]: {
        fontSize: FONTS.SIZES.xs,
        fontWeight: FONTS.WEIGHTS.medium,
      },
    },
  },
  cardButton: {
    '&&': {
      minWidth: '100px',
      backgroundColor: theme.palette.custom.secondary,
      borderRadius: '20px',

      '&:disabled': {
        backgroundColor: theme.palette.custom.grey,
      },
    },
  },
  cardButtonDisabled: {
    '&&': {
      backgroundColor: theme.palette.custom.grey,
    },
  },
  buttonIcon: {
    '&&': {
      fill: theme.palette.custom.darkBlue2,
      width: 18,
      height: 18,
    },
  },
  buttonText: {
    '&&': {
      fontWeight: FONTS.WEIGHTS.bold,
      fontSize: FONTS.SIZES.s,
      lineHeight: 1.333,
      textTransform: 'none',

      color: theme.palette.custom.darkBlue2,
    },
  },
}))

export default useStyles
